module.exports = __webpack_public_path__ + "static/header.2x-bf62f1e1f3ba5bb7e2ec60b469c15fe4.jpg";